"use client";

import { useEffect, useState } from "react";
import Link from "next/link";
import { Button } from "@/components/ui/button";
import { ArrowRight, Mail, Phone } from "lucide-react";
import { DEFAULT_IMAGES, CONTACT } from "@/lib/constants";
import {  fetchSolutionData } from "@/lib/api";
import { SolutionCard } from "@/components/shared/solution-card";


export default function SolutionsPageClient() {
  const [selectedCategory, setSelectedCategory] = useState("");
  const [solutions, setSolutions] = useState([]);

  useEffect(() => {
    const initLoad = async () => {
      const fetchSolution = await fetchSolutionData(selectedCategory);
      setSolutions(fetchSolution);
    };
    initLoad();
  }, [selectedCategory]);

  return (
    <>
      {/* Solutions Section */}
      <section className="px-4 pt-10 pb-20 sm:px-6 lg:px-8">
        <div className="mx-auto max-w-7xl">
          {/* Solutions Grid */}
          <div className="grid gap-7 sm:grid-cols-2 lg:grid-cols-3">
            {solutions.map((solution: any) => {
              return (
                <SolutionCard key={`product-${solution.slug}`} solution={solution} />
              );
            })}
          </div>

          {solutions.length === 0 && (
            <div className="text-center py-16">
              <p className="text-muted-foreground text-base">
                Không tìm thấy Giải pháp
              </p>
            </div>
          )}
        </div>
      </section>

    </>
  );
}
